import styled from 'styled-components';
import { font } from 'app/shared/styles/_fontsize';
import { colors } from 'app/shared/styles/_colors';
import { stacked } from 'app/shared/styles/_spacing';

import Linker from 'app/shared/modules/Linker';

export const BlurbParagraph = styled.p`
  ${font.tiny};
  ${stacked._2x};
`;

export const SemanticDivider = styled.hr`
  border: none;
  border-top: 1px solid ${colors['$hpx-grey-500']};
  margin: 40px 0px;
`;

export const BlurbLink = styled(Linker)`
  &:focus {
    outline: -webkit-focus-ring-color auto 1px;
    outline-offset: 5px;
  }
`;
